module.exports = __webpack_public_path__ + "static/img/solution-sucking.333c51a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/solution-sucking.png
// module id = ihie
// module chunks = 0